import { render, staticRenderFns } from "./boarding.vue?vue&type=template&id=753898a6&"
import script from "./boarding.vue?vue&type=script&lang=js&"
export * from "./boarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports